import { Box } from "@mui/material";

import MailsAccordion from "../Notifications/MailsNotifications/MailsAccordion";

const NotificationSettingsTab = () => {
  return (
    <Box>
      <MailsAccordion />
    </Box>
  );
};

export default NotificationSettingsTab;
